import type { Preset } from '@/core/project/preset';
import { builtInRecipe } from './app-params';

/**
 * The recipe chosen when the home page opens without a link naming one (see
 * `parseAppParams` for links that do): nothing applied, so a video dropped
 * without a choice opens in the plain editor and nothing starts by itself.
 */
export const DEFAULT_RECIPE: Preset = builtInRecipe('blank')!;
